/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Account')
    .factory('AccountDetailsModal', [
        '$modal',
        '$rootScope',
        '$translate',
        function (
            $modal,
            $rootScope,
            $translate,
        ) {
            return () => $modal.open({
                domOptions: {
                    modalAction: 'updateDetails',
                    modalType: 'notify',
                    modalTitle: $translate.instant('Account Details'),
                    modalBodyTemplate: 'account/details',
                    modalFooterTemplate: 'account/details_footer',
                },
                controller: 'AccountController',
                size: 'md',
                windowClass: 'account-details-dialog',
                backdrop: 'static',
                keyboard: false,
                scope: $rootScope.$new()
            }).result;
        }
    ]);
